import { createContext, useContext } from 'react'
import type { AppModule } from '@vectorhub/domain'

const CurrentModuleContext = createContext<AppModule | null>(null)

export const CurrentModuleProvider = CurrentModuleContext.Provider

/**
 * Returns the current module definition (icon, label, description),
 * or null outside a module route. Set by ModuleEntry.
 */
export function useCurrentModule(): AppModule | null {
  return useContext(CurrentModuleContext)
}
